/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentRecurrenceFormEvery: "shipment-recurrence-form-every",
  shipmentRecurrenceFormDays: "shipment-recurrence-form-days",
  shipmentRecurrenceFormRepeat: "shipment-recurrence-form-repeat",
} as const;
